import React, { ReactElement } from 'react';
import { useTranslation } from 'utils/localization';
import styles from './PasswordHelp.module.scss';

const Info = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <div>
            <div className={styles.passwordFormatTitle}>
                <span>{t('Info.title')}</span>
            </div>
            <div>{t('Info.list1')}</div>
        </div>
    );
};

export default Info;
